module.exports = __webpack_public_path__ + "img/poly-5.58a68193.png";